import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, Input, SimpleChanges, OnChanges, ElementRef } from '@angular/core';
import { SolarBaseComponent } from '@solar/solar/solar-base';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertType } from 'base-models';
import { MessageError } from 'base-models';
import { SortHelper } from 'shtools';
import { OlMainComponent, OlMapOptions } from 'gmap';
import { Site, Supervision, SupervisionError, InfoIssue, SupervisionStatusEnum } from 'solar-bo';
import { FrLayer, FrCoordinate } from 'gmap';

import { ChartService } from 'fr-chart';


import { OlObjectTypeEnum } from 'solar-bo';;
import { IssueImageComponent } from '../../supervis/issueimage/issueimage.component';
import { MapSupervisionHelper,MapIssueOverlay,MapSiteHelper } from '@solar/ol';
import { MapOnMoveHelper } from 'gmap';
import { MapTooltipHelper } from 'gmap';
import { DBFilterComponent } from '../db-filter/db-filter.component';
import { DashboardService } from '../../services/dashboard.service';
import { SolarBase1Component } from '@solar/solar/solar-base';

import { ErrorcontrolService } from 'basecomponents';
import { DashBoardHelper } from '../dashboard-helpers';
import { MapSupervisionIssues } from '@solar/ol';
import { SupervisLoader } from '../../supervis/superv-main/supervis-loader';
import { IssueTypeHelper } from '@solar/solar/models';

import { IDB_filter, IDB_Chart_Res, DB_filter, DBColumnsEnum, IFilterItem, FilterItem, GenFilter, FilterItemCollection ,IFilterItemCollection} from '../db-filter/filter';
import { TooltipIssue } from '@solar/ol/tooltip-issue.model';
/* import { DbFilter } from '../db-overview/db-filter-helper';
import { IDB_Chart_Res, DBColumnsEnum, IDB_filter, DB_filter } from 'solar-bo'; */


declare var google: any;

//providers:[DashboardService]
@Component({
  selector: 'app-db-superv-overview',
  templateUrl: './db-superv-overview.component.html',
  styleUrls: ['./db-superv-overview.component.scss']
})
export class DbSupervOverviewComponent extends SolarBase1Component implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  @Input() title: string="";
  @Input() site: Site;
  @Input() supervision: Supervision;
  @Input() chartcontainerwidth:string="chart-container-width-50";
  @Input() dbSupervOverview_options:{showTitle:boolean,title:string, titleSub: string}={showTitle:true,title:"Supervision", titleSub: ""};
  
  site_panels_type:any[]=[];
  site_panels:any[]=[];
  issues: SupervisionError[] = [];
  dataloaded:boolean=false;
  

  @ViewChild('map_db') map: OlMainComponent;
  private firstload = true;//en la primera carga 

  private chartLib: any;//google

  public dbFilter: GenFilter = new GenFilter();
  //map
    /**
   * layer object with issues
   */
  layer_Issues: any;
  mapSupervisionIssues:MapSupervisionIssues;
  mapcomponent_options: OlMapOptions = new OlMapOptions({ zoomPosition: 'LEFT' ,showCoords: true });
  

  constructor(
    private dashService: DashboardService
    , private chartService: ChartService

  ) {
    super();

    this.chartLib = this.chartService.getLibrary();
    this.mapSupervisionIssues=new MapSupervisionIssues();
  }

  ngOnInit() {
    console.log("DbOverviewComponent ngOnInit");
/*     this.supervision.site=this.site;
    this.configSiteFilter(); */
    this.mapcontrol = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    let typeChange = changes['supervision'];
    console.log ("ngOnChanges", typeChange);
    if (typeChange) {
      if (!this.supervision) {
        return;
      }
      this.supervision.site=this.site;
      this.configData();
      if (this.map){
        let prevSupervision=typeChange.previousValue;
        let parentLayer = this.map.layerGetByFrid(prevSupervision.id);
        if (parentLayer) {
          this.map.layerRemove(parentLayer.frlayerinfo.id);
        }
      }
    }
  }



  mapcontrol: boolean = true;
  issueOverlay: MapIssueOverlay;
  tooltipOverlay: MapIssueOverlay;
  mapOnMoveHelper: MapOnMoveHelper;
  mapIssueTooltip:TooltipIssue;
  @ViewChild('mapTooltip') mapTooltip:ElementRef;

  ngAfterViewInit() {
    this.chartLib.charts.load('current', { 'packages': ['corechart'] });
    // give everything a chance to get loaded before starting the animation to reduce choppiness
    console.log("DbOverviewComponent ngAfterViewInit");
    //this.dbFilter.selectionChange.subscribe(res => this.selectionChangeHandler(res));
    if (this.map) {
      console.log("DbOverviewComponent ngAfterViewInit refesh map");
      
      this.map.onFeatureClick.subscribe(res => this.onFeatureClick(res));
      
      this.issueOverlay = new MapIssueOverlay(this.map);
      this.issueOverlay.showText=false;

      this.tooltipOverlay = new MapIssueOverlay(this.map);
      this.tooltipOverlay.addLayer('sitesmarkers');

      this.mapOnMoveHelper = new MapOnMoveHelper(this.map);
      this.mapOnMoveHelper.addListener(this.issueOverlay);
      this.mapOnMoveHelper.addListener(this.tooltipOverlay);    
      
      this.mapIssueTooltip=new TooltipIssue(this.map, this.mapTooltip);
      
    }
  }

  ngOnDestroy() {
    console.log("DbOverviewComponent ngOnDestroy");
    this.mapcontrol = false;
  }

  private initialDataLoaded={"supervision":false, "site_panelstype":false, "site_panels":false, "supervision_issues":false};
  getInitialData(id_supervision:string){
    let cl=new SupervisLoader(this.solarService);
    if (this.supervision.info.status==SupervisionStatusEnum.VALIDATED){
      //get data only of issues validated
      cl.filter_supervisionStatus=SupervisionStatusEnum.VALIDATED;
    }
    cl.getSupervisionData(id_supervision);
    cl.configEndEvent.subscribe(res=>this.configureDataTree(res));
    cl.configErrorEvent.subscribe(res=>this.handleError(res));
  }

  configureDataTree(res){

    this.supervision=res.supervision;
    this.site=this.supervision.site;
    this.site_panels_type=res.site_panels_type;
    this.site_panels=res.site_panels;
    this.issues=res.issues;    
    //this.issuesFiltered = this.issues;
    this.dbFilter=new GenFilter();
    let elemSelected: IFilterItemCollection[] = [];
    this.selectionChangeHandler(elemSelected);

    this.configFilters();
    this.drawSitesOnMap();
    this.drawPanelErrorsOnMap(this.supervision, this.issues);
    //if (this.issues.length<1000){
      this.map.setZoomToExtent(this.layer_Issues);
    //}
    

    this.alertmessage = null;
    this.loading = false;
    this.dataloaded=true;
}

  onFeatureClick(features: any[]) {
    console.log(features);
    if (!features) {
      return;
    }
    for (let featInfo of features) {
      let feat=featInfo.feature;
      let layerInfo: FrLayer = feat.frlayerinfo;
      if (layerInfo) {
        if (layerInfo.ref == OlObjectTypeEnum.issue) {
          let issue = this.issues.find(issue => issue.id == layerInfo.id);
          if (issue) {            
            IssueImageComponent.openModal(this.dialog, issue, issue.supervision);
            return;
          }

        }
      }
    }
  }

  configData(): void {
    this.listerrmessage = '';
    this.loading = false;

    this.alertmessage = new MessageError(AlertType.Info, "Loading results for dashboard");
    this.listerrmessage = '';
    this.loading = true;

    let sites = new DB_filter(DBColumnsEnum.site_id, null);
    sites.value = [this.site];

    
    this.getInitialData(this.supervision.id);
    
  }

  getSiteListhandleError<T>(err: any) {
    this.loading = false;
    this.alertmessage =ErrorcontrolService.basichandleError("", err);
    
  }

  private sitesDrawed = false;
  drawSitesOnMap(force?: boolean) {
    if (force) {
      this.sitesDrawed = false;
    }
    if (!this.map || this.sitesDrawed) {
      return;
    }
    try {
      let site: Site = this.site;
      if (!site) {
        return;
      }

      let frlayerinfo = new FrLayer('Sites', 'sitesmarkers');
      let layer = this.map.layerGetByFrid(frlayerinfo.id);
      if (layer) {
        this.map.layerRemove(frlayerinfo.id);
      }
      layer = this.map.layerCreateVectorLayer(frlayerinfo);

      let mapSitesHelper = new MapSiteHelper();


      if (site.info.location != null) {
        mapSitesHelper.markerCreate(layer, site.info.location[0], site.info.location[1], site.id, site.name);
        this.map.setLocation(new FrCoordinate(site.info.location[0], site.info.location[1], 19));
      }

      this.map.layerAdd(layer);

      this.sitesDrawed = true;
    } catch (ex) {
      console.log(ex);
      this.alertmessage = new MessageError(AlertType.Info, "Error loading map" + ex);
    }
  }

  filterOpenModal() {
    let dialogRef: MatDialogRef<DBFilterComponent> = DBFilterComponent.openModal(this.dialog, this.dbFilter);
    dialogRef.componentInstance.selectedEvent.subscribe(res => {
      dialogRef.close(),
        this.filterSelectedEventHandler(res)
    });
  }

  /**
     * Handler when user clicks on filter view
     * @param selection 
     */
  filterSelectedEventHandler(filters: IFilterItemCollection[]) {
    if (!filters) {
      return;
    }
    
    this.selectionChangeHandler(filters);
  }

  selectionChangeHandler(filters?: IFilterItemCollection[]) {
    if (!filters) {
      return;
    }

    let sites: IFilterItemCollection = filters.find(elem => elem.id_filter === DBColumnsEnum.site_id);
    if (sites) {
      let sites_filter = [];
      for (let wvalue of sites.value) {
        sites_filter.push(wvalue.id);
      }

      sites.value = sites_filter;      
    }
    //let supervisionFilter = new DB_filter(DBColumnsEnum.id_supervision, null);
    let supervisionFilter=new FilterItemCollection(DBColumnsEnum.id_supervision);
    supervisionFilter.addItemsByList([this.supervision.id]);
    filters.push(supervisionFilter);


    this.dashService.db_siteResultsFilterByCount(this.supervision.id,DBColumnsEnum.issue_type, filters)
      .subscribe(
        reslist => this.chart_siteissues(reslist)
        , err => this.getSiteListhandleError(err)
      );

    this.dashService.db_siteResultsFilterByCount(this.supervision.id,DBColumnsEnum.relevance, filters)
      .subscribe(
        reslist => this.chart_siteissuesrelevance(reslist)
        , err => this.getSiteListhandleError(err)
      );

    this.dashService.db_siteResultsFilterByCount(this.supervision.id,DBColumnsEnum.panel_model, filters)
      .subscribe(
        reslist => this.chart_IssueModuleTypeData(reslist)
        , err => this.getSiteListhandleError(err)
      );

    this.dashService.db_siteResultsFilterByCount(this.supervision.id,DBColumnsEnum.panel_brand, filters)
      .subscribe(
        reslist => this.chart_IssueModuleBrandData(reslist)
        , err => this.getSiteListhandleError(err)
      );

      this.mapSupervisionIssues.filterSelected=filters;
      if (this.layer_Issues){
        this.layer_Issues.changed();
      }
  }

  configFilters() {

    let filterSites=new FilterItemCollection(DBColumnsEnum.site_id);              
    filterSites.addItems("id","name",[this.site]);
    this.dbFilter.addFilter(filterSites);


    let supervisionFilter = new FilterItemCollection(DBColumnsEnum.id_supervision);
    supervisionFilter.addItems("id","name",[this.supervision]);
    let filters=[];
    filters.push(supervisionFilter);

    this.dashService.db_siteResultsFilterBy(this.supervision.id, [DBColumnsEnum.issue_type],  DBColumnsEnum.issue_type, filters )
      .subscribe(
        reslist => {
          let lst = reslist.map(function (item) {
            return item[DBColumnsEnum.issue_type];
          });
          let filter=new FilterItemCollection(DBColumnsEnum.issue_type);
          if (lst.length > 0) {
            lst = reslist.map(function (item) {
              let fitem=new FilterItem();
              fitem.id=item[DBColumnsEnum.issue_type];
              fitem.value=fitem.id;
              fitem.viewname=IssueTypeHelper.issueGetErrorTypeDescription(fitem.id);
              return fitem;
            });

          }           
          lst = SortHelper.sortMultiple(lst, ["viewname"], ['asc']); //_.orderBy(users, ['user', 'age'], ['asc', 'desc']);  
          filter.addItemsByFilterItemList(lst);

          this.dbFilter.addFilter(filter);
        }
        , err => this.getSiteListhandleError(err)
      );

     this.dashService.db_siteResultsFilterBy(this.supervision.id, [DBColumnsEnum.relevance],  DBColumnsEnum.relevance, filters )
      .subscribe(
        reslist => {
          let lst = reslist.map(function (item) {
            return item[DBColumnsEnum.relevance];
          });
          lst=lst.sort();
          let filter=new FilterItemCollection(DBColumnsEnum.relevance);              
          filter.addItemsByList(lst);
          this.dbFilter.addFilter(filter);
        }
        , err => this.getSiteListhandleError(err)
      );

    this.dashService.db_siteResultsFilterBy(this.supervision.id,  [DBColumnsEnum.panel_model],  DBColumnsEnum.panel_model, filters )
      .subscribe(
        reslist => {
          let lst = reslist.map(function (item) {
            return item[DBColumnsEnum.panel_model];
          });
          lst=lst.sort();
          let filter=new FilterItemCollection(DBColumnsEnum.panel_model);              
          filter.addItemsByList(lst);
          this.dbFilter.addFilter(filter);
        }
        , err => this.getSiteListhandleError(err)
      );

    this.dashService.db_siteResultsFilterBy(this.supervision.id,  [DBColumnsEnum.panel_brand],  DBColumnsEnum.panel_brand, filters )
      .subscribe(
        reslist => {
          let lst = reslist.map(function (item) {
            return item[DBColumnsEnum.panel_brand];
          });
          lst=lst.sort();
          let filter=new FilterItemCollection(DBColumnsEnum.panel_brand);              
          filter.addItemsByList(lst);
          this.dbFilter.addFilter(filter);
        }
        , err => this.getSiteListhandleError(err)
      ); 
  }


  
  drawPanelErrorsOnMap(superv: Supervision, reslist: SupervisionError[]) {
    //creamos la capa que encapsula los errores
    let layerinfo: FrLayer = new FrLayer('Supervision ' + superv.name, superv.id, 15);
    let parentLayer = this.map.layerCreateVectorLayer(layerinfo);
    parentLayer.setStyle(this.mapSupervisionIssues.panelsFilterStyle.bind(this.mapSupervisionIssues));
    this.layer_Issues = parentLayer;
    this.map.layerAdd(parentLayer);

    
    let panelPattern = Site.getPanelPattern(this.site, "maps");

    for (let x = 0; x < reslist.length; x++) {
      let obj: SupervisionError = reslist[x];
      obj.supervision = superv;
      MapSupervisionHelper.issuePolygonDraw(obj, parentLayer,panelPattern,true);
    }

    this.issueOverlay.layersId.push(superv.id);

    this.listerrmessage = "";
    this.loading = false;
  }

  chartSitePowerData: any;
  chart_sitepower(filterList) {
    let data = new this.chartLib.visualization.DataTable();
    data.addColumn('string', 'Module');
    data.addColumn('number', 'Power');
    data.addColumn('number', 'Lost');
    /*     dt.push([
          { label: 'Site', id: 'Site' },
          { label: 'Power', id: 'Power', type: 'number' },
          { label: 'Lost', id: 'lost', type: 'number' }
        ]); */

    for (let i = 0; i < filterList.length; i++) {
      let site: Site = filterList[i];
      let power: number = 0;
      if (site.info.power != null) {
        power = +site.info.power;
      }
      let sitepower = Math.floor(power);
      let sitepowerlost = Math.floor(sitepower * 0.10);
      data.addRow([
        site.name,
        sitepower,
        sitepowerlost
      ]);
    }

    this.chartSitePowerData = data;
  }

  chartIssueTypeData: any;
  chartIssueTypeOptionsExt: any = {
    height: "400px"
  }
  //chartIssueTypeOptions = { "legend": "none" };
  chartIssueTypeOptions: any = {
    mainTitle: 'Issues by type',
    /*legend: { position: 'bottom', maxLines: 3 },*/
    legend: 'none'
    ,backgroundColor: 'transparent'
    ,bar: { groupWidth: '75%' },
    isStacked: false,
    vAxis: { title: "Error count" },
    hAxis: {
      direction: 1, slantedText: true, slantedTextAngle: 45, textPosition: "out"
      , textStyle: {
        fontSize: 10 
      }
    }
    , annotations: {
      alwaysOutside: true,
      textStyle: {
        fontSize: 10,
        auraColor: 'none'
      }
    }
    ,tooltip: {isHtml: true}
  };
  chart_siteissues(source?: IDB_Chart_Res[]) {
    try {
      let data = new this.chartLib.visualization.DataTable();
      data.addColumn('string', 'Issue');
      data.addColumn('number', 'Count');
      data.addColumn({ role: 'style' });
      data.addColumn({type:'string' , role: 'tooltip', 'p': {'html': true} });
      if (source) {
        let sourceOrdered: any[] = SortHelper.sortMultiple(source, ["count"], ['desc']); //_.orderBy(users, ['user', 'age'], ['asc', 'desc']);
        //console.log("chartIssueTypeData", sourceOrdered);
        for (let x = 0; x < sourceOrdered.length; x++) {
          let issueType = sourceOrdered[x]["issue_type"];
          let issueCount=+sourceOrdered[x]["count"];
          let issueDescription= DashBoardHelper.chartIssueDescription(issueType);
          let issueColor= IssueTypeHelper.issueGetErrorTypeColor(issueType);
          //data.addRow([sourceOrdered[x]["issue_type"], +sourceOrdered[x]["count"], DashBoardHelper.chartIssueColor(sourceOrdered[x]["issue_type"])]);
          
          let tooltip='<div style="padding:5px 5px 5px 5px;"><b style="white-space: nowrap">' + issueDescription +'</b><br><span style="white-space: nowrap">Errors: <b>' + issueCount +'</span></b></div>';

          data.addRow([issueDescription,issueCount , issueColor,tooltip]);
        }
      }
      this.chartIssueTypeData = data;
    }
    catch (error) {

    }
  }

  chartGetRandomColor() {
    let letters = '0123456789ABCDEF'.split('');
    let color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  chartIssueRelevanceData: any;
  chartIssueRelevanceOptions: any = {
    mainTitle: 'Issues by relevance',
    backgroundColor: 'transparent'

  };
  chart_siteissuesrelevance(source?: IDB_Chart_Res[]) {
    try {
      let data = new this.chartLib.visualization.DataTable();
      data.addColumn('string', 'Issue Relevance');
      data.addColumn('number', 'Quantity');
      /*     data.addRows([
            ['Muy baja:	0 ºC ≤ Tc‐To < 10 ºC', 3],
            ['Baja:	10 ºC ≤ Tc‐To < 20 ºC', 6],
            ['Media:	20 ºC ≤ Tc‐To < 30 ºC', 4],
            ['Alta:	30 ºC ≤ Tc‐To < 100 ºC', 5],
            ['Muy alta:	Tc‐To ≥ 100 ºC', 2]
          ]); */
      if (source) {
        let sourceOrdered: any[] = SortHelper.sortMultiple(source, ["count"], ['desc']); //_.orderBy(users, ['user', 'age'], ['asc', 'desc']);
        for (let x = 0; x < sourceOrdered.length; x++) {
          data.addRow([sourceOrdered[x]["relevance"], +sourceOrdered[x]["count"]]);//, this.chartIssueColor(sourceOrdered[x][0])]);
        }
      }

      let view = new google.visualization.DataView(data);
      this.chartIssueRelevanceData = view;
    }
    catch (error) {

    }
  }


  chartIssueModuleBrandData: any;
  chartIssueModuleBrandOptions: any = {
    mainTitle: 'Issues by manufacturer',
    backgroundColor: 'transparent'

  };
  chart_IssueModuleBrandData(source?: IDB_Chart_Res[]) {
    let data = new this.chartLib.visualization.DataTable();
    data.addColumn('string', 'Brand');
    data.addColumn('number', 'Quantity');

    if (source) {
      let sourceOrdered: any[] = SortHelper.sortMultiple(source, ["count"], ['desc']); //_.orderBy(users, ['user', 'age'], ['asc', 'desc']);
      for (let x = 0; x < sourceOrdered.length; x++) {
        data.addRow([sourceOrdered[x][DBColumnsEnum.panel_brand], +sourceOrdered[x]["count"]]);//, this.chartIssueColor(sourceOrdered[x][0])]);
      }
    }
    this.chartIssueModuleBrandData = data;
  }


  chartIssueModuleTypeData: any;
  chartIssueModuleTypeOptions: any = {
    mainTitle: 'Issues by module',
    backgroundColor: 'transparent'

  };
  chart_IssueModuleTypeData(source?: IDB_Chart_Res[]) {
    let data = new this.chartLib.visualization.DataTable();
    data.addColumn('string', 'Module');
    data.addColumn('number', 'Quantity');

    if (source) {
      let sourceOrdered: any[] = SortHelper.sortMultiple(source, ["count"], ['desc']); //_.orderBy(users, ['user', 'age'], ['asc', 'desc']);
      for (let x = 0; x < sourceOrdered.length; x++) {
        data.addRow([sourceOrdered[x]["panel_model"], +sourceOrdered[x]["count"]]);//, this.chartIssueColor(sourceOrdered[x][0])]);
      }
    }
    this.chartIssueModuleTypeData = data;
  }






}
